export default {
  hasBanners(state) {
    return state.banners.length > 0
  },
}
